// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReasonStep_textarea-wrapper__aMHNP {
  padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/views/Payment/PaymentSteps/ReasonStep/ReasonStep.module.scss"],"names":[],"mappings":"AAGA;EACE,oBAAA;AAFF","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.textarea-wrapper {\n  padding-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textarea-wrapper": `ReasonStep_textarea-wrapper__aMHNP`
};
export default ___CSS_LOADER_EXPORT___;
